import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useContext, useEffect, useState } from 'react';
import { GrupoType, useAddGrupos } from '../../hooks/useGrupos';
import { UserContext } from '../../contexts/userContext';
import { IndicatorButton } from '../IndicatorButton';
export interface AlumnosDetailProps {
  grupo?: GrupoType;
  open: boolean;
  onClose: () => void;
  refetchLista: () => void;
}

export default function GrupoDetail(props:AlumnosDetailProps) {
  const { grupo, open, onClose, refetchLista } = props;
  const [ mutableGrupo, setMutableGrupo ] = useState<GrupoType | undefined>();
  const { user } = useContext(UserContext);

  const addGrupo = useAddGrupos(mutableGrupo, user);

  useEffect(() => {
    if (addGrupo.data?._id && !addGrupo.isLoading) {
      setTimeout(() => refetchLista(), 500);
      setMutableGrupo(undefined);
      onClose();
    }
  }, [addGrupo.data]);

  const descartar = () => {
    setMutableGrupo(undefined);
    onClose();
  };

  useEffect(() =>{
    setMutableGrupo(grupo);
  }, [grupo]);

  const handleSubmit = () => {
    addGrupo.refetch();
  };

  let titulo = '';
  if (grupo) titulo = 'Editar Nombre de Grupo';
  if (!grupo) titulo = 'Crear Nuevo Grupo';


  return (
    <div>
      <Dialog open={open} >
        <DialogTitle>{titulo}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="name"
            label="Nombre"
            type="text"
            fullWidth
            variant="standard"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setMutableGrupo((prev) => ({ ...prev, nombre: (event.target as HTMLInputElement).value as string }));
            }}
            value={mutableGrupo?.nombre ?? ''}
            required
            error={!mutableGrupo?.nombre}
            helperText={!mutableGrupo?.nombre ? 'El Nombre no puede quedar vacio' : ''}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={!!mutableGrupo?.esEquipo}
                onChange={(event) => {
                  setMutableGrupo((prev) => prev ? { ...prev, esEquipo: event.target.checked } : prev);
                }}
              />
            }
            label="Grupo equipo (paga seguro)"
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            disabled={addGrupo.isLoading}
            onClick={descartar}
          >
               Descartar
          </Button>
          <IndicatorButton
            label='Guardar Cambios'
            disabled={!mutableGrupo?.nombre}
            loading={addGrupo.isLoading}
            onClick={handleSubmit}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
